

export const calculateProviderUtilization = (
  {
    shiftDuration,
    visitResourcesDuration,
    breaksDuration,
  }: { shiftDuration:number, visitResourcesDuration: number, breaksDuration: number }
) => {
  const effectiveShiftTime = shiftDuration - breaksDuration;
  return effectiveShiftTime > 0 ? Math.round(
    (visitResourcesDuration / effectiveShiftTime) * 100
  ) : 0;
}

export const calculateCancellationRate = ({
  totalVisits,
  totalCanceledVisits,
}: {
  totalVisits: number,
  totalCanceledVisits: number
}) => {
  return totalVisits > 0
  ? Math.round((totalCanceledVisits / totalVisits) * 100)
  : 0;
}
